import { useEffect } from 'react';

export default function SerenaPage() {
  useEffect(() => {
    // Abre a Serena automaticamente após a página carregar
    const timer = setTimeout(() => {
      const serenaButton = document.querySelector(
        '#vapi-widget-floating-button',
      ) as HTMLElement;
      if (serenaButton) {
        serenaButton.click();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const openWhatsApp = () => {
    window.open('https://wa.me/5521994740504?text=Olá, quero equilibrar minha mente agora', '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-amber-50 flex items-center justify-center px-6">
      <div className="max-w-2xl w-full text-center">
        {/* Logo e Título */}
        <div className="mb-8">
          <div className="w-20 h-20 bg-teal-700 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
            <i className="ri-brain-line text-white text-4xl"></i>
          </div>
          <h1
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-3"
            style={{ fontFamily: 'Pacifico, serif' }}
          >
            Equilibrada🧠Mente™
          </h1>
          <p className="text-xl text-teal-700 font-medium mb-2">
            Reginaldo Silva - Psicoterapeuta
          </p>
        </div>

        {/* Card Principal */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 mb-8">
          <div className="mb-6">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-2-line text-teal-600 text-3xl"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Olá! Sou a Serena 👋
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Assistente virtual do Equilibrada🧠Mente™. Estou aqui para ajudar você a agendar sua consulta e responder suas dúvidas sobre nossos serviços de psicoterapia.
            </p>
          </div>

          {/* Indicador de Carregamento */}
          <div className="bg-teal-50 rounded-lg p-6 mb-6">
            <div className="flex items-center justify-center space-x-3 mb-3">
              <div className="w-3 h-3 bg-teal-600 rounded-full animate-pulse"></div>
              <div className="w-3 h-3 bg-teal-600 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
              <div className="w-3 h-3 bg-teal-600 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
            </div>
            <p className="text-teal-700 font-medium">
              Abrindo o chat da Serena...
            </p>
            <p className="text-sm text-gray-600 mt-2">
              O chat abrirá automaticamente em instantes
            </p>
          </div>

          {/* Benefícios */}
          <div className="grid md:grid-cols-2 gap-4 mb-6">
            <div className="flex items-center space-x-3 text-left">
              <i className="ri-calendar-check-line text-teal-600 text-xl"></i>
              <span className="text-gray-700 text-sm">Agende sua consulta</span>
            </div>
            <div className="flex items-center space-x-3 text-left">
              <i className="ri-question-answer-line text-teal-600 text-xl"></i>
              <span className="text-gray-700 text-sm">Tire suas dúvidas</span>
            </div>
            <div className="flex items-center space-x-3 text-left">
              <i className="ri-time-line text-teal-600 text-xl"></i>
              <span className="text-gray-700 text-sm">Atendimento rápido</span>
            </div>
            <div className="flex items-center space-x-3 text-left">
              <i className="ri-shield-check-line text-teal-600 text-xl"></i>
              <span className="text-gray-700 text-sm">100% confidencial</span>
            </div>
          </div>

          {/* Botão WhatsApp Alternativo */}
          <div className="border-t border-gray-200 pt-6">
            <p className="text-gray-600 mb-4">
              Prefere falar direto no WhatsApp?
            </p>
            <button
              onClick={openWhatsApp}
              className="bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-green-700 transition-colors flex items-center justify-center gap-2 mx-auto cursor-pointer whitespace-nowrap shadow-lg"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              (21) 99474-0504
            </button>
          </div>
        </div>

        {/* Informações Adicionais */}
        <div className="text-center">
          <p className="text-gray-600 mb-4">
            Método exclusivo de psicoterapia para saúde mental feminina
          </p>
          <div className="flex items-center justify-center space-x-6 text-sm text-gray-500">
            <div className="flex items-center space-x-2">
              <i className="ri-map-pin-line text-teal-600"></i>
              <span>Rio de Janeiro, RJ</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-global-line text-teal-600"></i>
              <span>Online e Presencial</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
